module.exports = __webpack_public_path__ + "img/menu-food-1.104d1faa.jpg";